/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps, IconSize} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) System Full Screen Exit Icon component.
 */
const SystemFullScreenExitIcon = ({
  size = IconSize.medium,
  color = dlsColor('grey1')
}: IconProps) => {
  const {iconSize, iconColor} = useIconDLS({color, size});
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M13.5676 11.1818L20.1594 4.5459M18.6594 11.1819L13.5676 11.1818V6.0458M11.1818 13.5678L4.5459 20.1597M11.1819 18.6596L11.1818 13.5678H6.0458' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export default React.memo(SystemFullScreenExitIcon);
